if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
        var interval = setInterval(function() {
    if(document.readyState === 'complete') {
      let prodFormContainer = document.querySelector('product-form');
      let prodForm = prodFormContainer.querySelector('form');
      let metaCount = prodForm.getAttribute('data-count');
        let itemProperty = document.querySelector('[name="properties[Customization Box]"]');
        let itemPropertyHulk = document.querySelector('#hulkapps_option_list_7818833625325');
        let letterButtonsParent = document.querySelector('fieldset[class*="quantity"],fieldset[class*="number-of"]');

        if (itemPropertyHulk != undefined) {
          console.log('1')
          let letterButtons = document.querySelector('.option_type_id_671250').querySelectorAll('label');
          const charMsg = document.querySelector('.char-msg');
          const errorMsg = document.querySelector('.error-msg');
          itemPropertyHulk.querySelector('textarea').addEventListener("keyup",function (e) {
            if(this.value.length == 0) {
              charMsg.style.display = "block";
              prodForm.addEventListener("submit", function(e) {
                e.preventDefault();
              });
            } else if (this.value.length >= letterButtons.length){
              errorMsg.style.display = "block";
              this.value = this.value.substring(0, letterButtons.length);
            } else {
              document.querySelector('.option_type_id_671250').querySelector("input[data-conditional-value='" + this.value.length + "']").click();
              errorMsg.style.display = "none";
              charMsg.style.display = "none";
              prodForm.addEventListener('submit', prodFormContainer.onSubmitHandler.bind(prodFormContainer));
            }
            e.preventDefault();
            return false
          });
        } else if (itemProperty != undefined && letterButtonsParent != undefined) {
          console.log('2')
          let letterButtons = document.querySelector('fieldset[class*="quantity"],fieldset[class*="number-of"]').querySelectorAll('label');
          const charMsg = document.querySelector('.char-msg');
          const errorMsg = document.querySelector('.error-msg');
          itemProperty.previousSibling.addEventListener("keyup",function (e) {
            if(this.value.length == 0) {
              charMsg.style.display = "block";
              prodForm.addEventListener("submit", function(e) {
                e.preventDefault();
              });
            } else if (this.value.length >= letterButtons.length){
              errorMsg.style.display = "block";
              this.value = this.value.substring(0, letterButtons.length);
              document.querySelector('fieldset[class*="quantity"],fieldset[class*="number-of"]').querySelector("[data-name*='" + this.value.length + "']").click();
            } else {
              document.querySelector('fieldset[class*="quantity"],fieldset[class*="number-of"]').querySelector("[data-name*='" + this.value.length + "']").click();
              errorMsg.style.display = "none";
              charMsg.style.display = "none";
              prodForm.addEventListener('submit', prodFormContainer.onSubmitHandler.bind(prodFormContainer));
            }
            e.preventDefault();
            return false
          });
        } else if (itemProperty != undefined && metaCount != '') {
          console.log('3')
          const charMsg = document.querySelector('.char-msg');
          const errorMsg = document.querySelector('.error-msg');
          itemProperty.previousSibling.addEventListener("keyup",function (e) {
            if (this.value.length >= metaCount) {
              errorMsg.style.display = "block";
              this.value = this.value.substring(0, metaCount);
            } else {
              errorMsg.style.display = "none";
              prodForm.addEventListener('submit', prodFormContainer.onSubmitHandler.bind(prodFormContainer));
            }
            e.preventDefault();
            return false
          });
        }

        if (itemProperty != undefined && itemProperty.value.length == 0) {
          prodForm.addEventListener("submit", function(e) {
            charMsg.style.display = "block";
             e.preventDefault();
          });
        } else {
          prodForm.addEventListener('submit', prodFormContainer.onSubmitHandler.bind(prodFormContainer));
        }

         clearInterval(interval);
    }    
  }, 100);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.dataset.cartType != 'page') {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.dataset.cartType == 'page') {
            window.location = window.routes.cart_url;
            return;
          }

          jQuery.getJSON('/cart.js', function(cart) {
            /* Free shipping */
            const shippingCountdownSelector = document.querySelectorAll(".shipping-countdown p span");
            const cleanCartTotal = (cart.items_subtotal_price) / 100;
            console.log(cleanCartTotal);
            const shippingThreshold = parseInt(document.querySelector(".shipping-countdown .shipping-threshold").innerText);
            const emptyCart = document.querySelectorAll(".shipping-countdown .empty-cart");
            const progressCart = document.querySelectorAll(".shipping-countdown .progress-cart");
            const fullCart = document.querySelectorAll(".shipping-countdown .full-cart");
      
            if(cleanCartTotal > 0 && cleanCartTotal < shippingThreshold) {
              for (var i = 0; i < emptyCart.length; i++) {
                emptyCart[i].style.display = "none";
              }
              for (var i = 0; i < fullCart.length; i++) {
                fullCart[i].style.display = "none";
              }
              for (var i = 0; i < progressCart.length; i++) {
                progressCart[i].style.display = "block";
              }
              for (var i = 0; i < shippingCountdownSelector.length; i++) {
                shippingCountdownSelector[i].innerHTML = '$' + parseFloat(shippingThreshold - cleanCartTotal).toFixed(2);
              }
            } else if(cleanCartTotal >= shippingThreshold) {
              for (var i = 0; i < emptyCart.length; i++) {
                emptyCart[i].style.display = "none";
              }
              for (var i = 0; i < progressCart.length; i++) {
                progressCart[i].style.display = "none";
              }
              for (var i = 0; i < fullCart.length; i++) {
                fullCart[i].style.display = "block";
              }
            } else if(cleanCartTotal == 0) {
              for (var i = 0; i < fullCart.length; i++) {
                fullCart[i].style.display = "none";
              }
              for (var i = 0; i < progressCart.length; i++) {
                progressCart[i].style.display = "none";
              }
              for (var i = 0; i < emptyCart.length; i++) {
                emptyCart[i].style.display = "block";
              }
            }
          });

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}